module.exports = __webpack_public_path__ + "static/media/games.e36fec58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/games.svg
// module id = 379
// module chunks = 7